import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { GuideCard } from '@hotjar/activation-toolkit';
import { Stack, Button, tokens } from '@hotjar/hotsauce';
import FUNNELS_SPLASH from '@hotjar/shared-assets/images/funnels-splash.svg';
import { useGuideCardVisibility } from '@hotjar/webapp/hooks/useGuideCardVisibility';

const FUNNELS_KB_URL = ' https://www.hotjar.com/product/funnels/';

const BannerImage = styled.div<{ src?: string }>`
  width: 100%;
  height: 100%;
  background-image: url('${({ src }) => src}');
  background-color: ${tokens.BRAND_COLORS.noon_100};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
`;

const WrapperDiv = styled.div`
  margin-bottom: ${tokens.spacer.x4};
`;

export const TrialGuideCard = (): React.ReactElement | null => {
  const { t } = useTranslation('funnels');
  const { isGuideCardVisible, dismissGuideCard } = useGuideCardVisibility('trial-funnels-intro');

  return (
    <>
      {isGuideCardVisible && (
        <WrapperDiv>
          <GuideCard
            label={t('scaleTrialGuide.label')}
            title={t('scaleTrialGuide.title')}
            description={
              <div style={{ whiteSpace: 'pre-line' }}>{t('scaleTrialGuide.description')}</div>
            }
            media={<BannerImage src={FUNNELS_SPLASH} />}
            onDismiss={dismissGuideCard}
            actions={
              <Stack direction="row">
                <Button
                  as="a"
                  href={FUNNELS_KB_URL}
                  kind="secondary"
                  isExternal
                  icon="open_new_window"
                >
                  {t('trialGuide.moreAboutFunnels')}
                </Button>
                <Button onClick={dismissGuideCard} kind="ghost">
                  {t('trialGuide.dismiss')}
                </Button>
              </Stack>
            }
          />
        </WrapperDiv>
      )}
    </>
  );
};
